const ADMIN_BASE = process.env.REACT_APP_ADMIN_PATH || '/admin';
import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Lock, Loader2, Diamond } from 'lucide-react';
import { useAdminAuth } from '../context/AdminAuthContext';

const AdminLogin = () => {
  const { login, isAuthed } = useAdminAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  if (isAuthed) return <Navigate to={ADMIN_BASE} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      await login(username, password);
      navigate(ADMIN_BASE);
    } catch (e2) {
      setErr(e2?.response?.data?.detail || 'Login failed. Check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] bg-[#1B1D21] flex items-center justify-center px-5 py-16">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-3 mb-8">
          <span className="relative flex items-center justify-center w-9 h-9">
            <span className="absolute inset-0 rotate-45 rounded-[6px] sunset-gradient" />
            <Diamond className="relative w-4 h-4 text-white" strokeWidth={2.5} />
          </span>
          <span className="font-display text-[22px] font-semibold text-white">Emirates Guide</span>
        </div>
        <div className="bg-[#F6F1E3] rounded-2xl p-8 shadow-2xl">
          <div className="flex items-center gap-2 text-[#e0564e]">
            <Lock className="w-5 h-5" />
            <span className="text-[12px] font-semibold tracking-[0.16em] uppercase">Admin area</span>
          </div>
          <h1 className="mt-2 font-display text-[28px] font-semibold text-[#1B1D21]">Sign in to the CMS</h1>
          <p className="mt-2 text-[14px] text-[#4B4F58]">Manage hotels, FAQs and emirate summaries.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="block text-[13px] font-semibold text-[#45596b] mb-1.5">Username</label>
              <input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                className="w-full rounded-xl bg-white border border-[#E6D7A2] px-4 py-3 text-[15px] text-[#1B1D21] outline-none focus:ring-2 focus:ring-[#e0564e]"
                placeholder="admin"
                required
              />
            </div>
            <div>
              <label className="block text-[13px] font-semibold text-[#45596b] mb-1.5">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                className="w-full rounded-xl bg-white border border-[#E6D7A2] px-4 py-3 text-[15px] text-[#1B1D21] outline-none focus:ring-2 focus:ring-[#e0564e]"
                placeholder="••••••••"
                required
              />
            </div>
            {err ? <p className="text-[14px] text-[#d6453c]">{err}</p> : null}
            <button
              type="submit"
              disabled={loading}
              className="btn-sunset w-full inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-[15px] font-semibold disabled:opacity-70"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
              Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
